import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { DishServices } from "../../../dish/services";
import { DishCreateNamePage } from "../../../dish/dish-create/dish-create-name/dish-create-name";
import { StaticsServices } from '../../../services/statics';
import { ProductsServices } from '../../../products/services';
import { MenuServices } from '../../../menu/services';
import { ComboCreatePricePage } from '../combo-create-price/combo-create-price';
import { ComboCreateFinishSectionPage } from '../combo-create-finish-section/combo-create-finish-section';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ComboCreateDishSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-create-dish-select',
  templateUrl: 'combo-create-dish-select.html',
})
export class ComboCreateDishSelectPage {

  type: any;
  section_index: any;
  section: any;
  update_state: boolean = false;
  combo_uid: string;
  combo_name: string;
  selected_collapse: boolean = false;
  show_prices: boolean = true;
  new_combo: boolean = false;

  /**
   * Falta que al editar iniciar los platos que ya estan en la seccion que se quiere editar.
   */

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public dishServices: DishServices,
    public toastCtrl: ToastController,
    public staticsServices: StaticsServices,
    public productServices: ProductsServices,
    public menuServices: MenuServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    private analyticsServices: AnalyticsServices) {

    this.type = this.navParams.get('type'); //Menu style
    this.section_index = this.navParams.get('section'); //Section index number
    this.update_state = this.navParams.get('update');//Update state
    this.combo_uid = this.navParams.get('combo_uid');//Menu uid
    this.combo_name = this.navParams.get('combo_name');//Menu uid
    this.show_prices = this.navParams.get('show_prices');//Menu uid
    this.new_combo = this.navParams.get('new_combo');


    if (!this.update_state && this.type == 'combo') { //combo new menu

      var _obj_combo: any;
      if (this.section_index == 0) {
        //Creamos array tmp
        _obj_combo = {
          0: {
            name: 'combo',
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1,
            combo_required: false,
            combo_select_multi: false,
            combo_cost_extra: false,
            //
            name_ca: '',
            name_en: '',
            name_it: '',
            name_de: '',
            name_fr: ''
          },
        };
        this.menuServices.menu_section_array_complete_tmp = _obj_combo;
      } else {
        //Si no es la primera seccion creamos solo la nueva seccion
        this.menuServices.menu_section_array_complete_tmp[this.section_index] = {
          name: 'combo',
          order: 0,
          font_size: 18,
          font_family: 'Arial',
          font_color: '#000',
          text_align: 'center',
          dish: Array(),
          column: 1,
          combo_required: false,
          combo_select_multi: false,
          combo_cost_extra: false,
          //
          name_ca: '',
          name_en: '',
          name_it: '',
          name_de: '',
          name_fr: ''
        };
      }
    }

    if (this.update_state) {
      if (!this.navParams.get('new')) {//Editem seccio
        var section_index_complete = this.navParams.get('section_complete');
        section_index_complete[this.section_index].name_ca = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_ca);
        section_index_complete[this.section_index].name_en = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_en);
        section_index_complete[this.section_index].name_it = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_it);
        section_index_complete[this.section_index].name_de = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_de);
        section_index_complete[this.section_index].name_fr = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_fr);

        var _dish = section_index_complete[this.section_index].dish; //Get the dish section's
        for (let key in _dish) {
          var _array = Array();

          _array.push(_dish[key].uid); //UID [0]
          _array.push(_dish[key].order !== undefined ? _dish[key].order : parseInt(key)); //Order [1]
          _array.push(_dish[key].name || ''); //[2]
          _array.push(_dish[key].name_ca || ''); //[3]
          _array.push(_dish[key].name_en || ''); //[4]
          _array.push(_dish[key].name_de || ''); //[5]
          _array.push(_dish[key].name_fr || ''); //[6]
          _array.push(_dish[key].name_it || ''); //[7]
          // Allergens [8] - Validar que sea un array
          if (Array.isArray(_dish[key].allergens)) {
            _array.push(_dish[key].allergens);
          } else {
            _array.push([]);
          }
          // Foodcost_static [9]
          if (_dish[key].foodcost_static !== undefined && _dish[key].foodcost_static !== null) {
            _array.push(parseFloat(_dish[key].foodcost_static) || 0);
          } else {
            _array.push(0);
          }
          // Foodcost_parts [10]
          if (_dish[key].foodcost_parts !== undefined && _dish[key].foodcost_parts !== null) {
            _array.push(parseFloat(_dish[key].foodcost_parts) || 0);
          } else {
            _array.push(0);
          }
          _array.push(_dish[key].type || 'dish'); //[11]
          // Price [12]
          if (_dish[key].price !== undefined && _dish[key].price !== null) {
            _array.push(parseFloat(_dish[key].price) || 0);
          } else {
            _array.push(0);
          }
          // Price_combo_extra [13]
          if (_dish[key].price_combo_extra !== undefined && _dish[key].price_combo_extra !== null) {
            _array.push(parseFloat(_dish[key].price_combo_extra) || 0);
          } else {
            _array.push(0);
          }
          // Price_takeaway [14]
          if (_dish[key].price_takeaway !== undefined && _dish[key].price_takeaway !== null) {
            _array.push(parseFloat(_dish[key].price_takeaway) || 0);
          } else {
            _array.push(0);
          }
          _array.push(_dish[key].description_es || ''); //[15]
          _array.push(_dish[key].description_ca || ''); //[16]
          _array.push(_dish[key].description_en || ''); //[17]
          _array.push(_dish[key].description_de || ''); //[18]
          _array.push(_dish[key].description_fr || ''); //[19]
          _array.push(_dish[key].description_it || ''); //[20]
          // Tags [21] - CRÍTICO: Validar que sea un array, si no lo es, usar array vacío
          if (Array.isArray(_dish[key].tags)) {
            _array.push(_dish[key].tags);
          } else {
            // Si tags existe pero no es array (datos corruptos), ignorarlo y usar array vacío
            _array.push([]);
          }
          // Image [22]
          if (_dish[key].image) {
            _array.push(_dish[key].image);
          } else {
            _array.push("");
          }

          this.menuServices.menu_dish_array_tmp.push(_array);
        }
        this.menuServices.menu_section_array_complete_tmp = section_index_complete;
      } else {
        this.menuServices.menu_section_array_complete_tmp = this.menuServices.menu_tmp.sections;

        this.menuServices.menu_section_array_complete_tmp[this.section_index] = {
          name: 'combo',
          order: 0,
          font_size: 18,
          font_family: 'Arial',
          font_color: '#000',
          text_align: 'center',
          dish: Array(),
          column: 1,
          //
          name_ca: '',
          name_en: '',
          name_it: '',
          name_de: '',
          name_fr: ''
        };
      }
    }
  }

  ionViewWillEnter() {
    this.menuServices.getPagesDishesProducts(0);
    this.menuServices.page_active = 1;
  }

  openMenuNext() {
    this.updateSection();// Anadimos los platos al array tmp de todas las secciones
    //abrir pagina intermedia
    this.navCtrl.push(ComboCreateFinishSectionPage, {
      type: "combo",
      section: Number(this.section_index) + 1,
      update: this.update_state,
      combo_uid: this.combo_uid,
      show_prices: this.show_prices,
      combo_name: this.combo_name,
      new_combo: this.new_combo
    });

  }

  updateSection() {
    this.rellenarIdiomasVacios();
    //Preparamos el objecto para insertarlo en los dish del menu
    var _obj = {};
    for (var i = 0; this.menuServices.menu_dish_array_tmp.length > i; i++) {
      this.menuServices.sumands = this.menuServices.sumands + this.menuServices.menu_dish_array_tmp[i][9];
      this.menuServices.count_tmp++;

      //Comprovamos que el elemento tenga la descripcion
      if (this.menuServices.menu_dish_array_tmp[i][13] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][13] = 0;
      }
      if (this.menuServices.menu_dish_array_tmp[i][14] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][14] = 0;
      }
      if (this.menuServices.menu_dish_array_tmp[i][15] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][15] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][16] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][16] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][17] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][17] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][18] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][18] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][19] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][19] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][20] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][20] = '';
      }
      // Validar allergens [8] - CRÍTICO: debe ser un array
      if (!Array.isArray(this.menuServices.menu_dish_array_tmp[i][8])) {
        this.menuServices.menu_dish_array_tmp[i][8] = [];
      }
      // Validar tags [21] - CRÍTICO: debe ser un array
      if (!Array.isArray(this.menuServices.menu_dish_array_tmp[i][21])) {
        this.menuServices.menu_dish_array_tmp[i][21] = [];
      }
      if (this.menuServices.menu_dish_array_tmp[i][22] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][22] = '';
      }

      _obj[i] = {
        uid: this.menuServices.menu_dish_array_tmp[i][0],
        order: this.menuServices.menu_dish_array_tmp[i][1],
        name: this.menuServices.menu_dish_array_tmp[i][2],
        name_ca: this.menuServices.menu_dish_array_tmp[i][3],
        name_en: this.menuServices.menu_dish_array_tmp[i][4],
        name_de: this.menuServices.menu_dish_array_tmp[i][5],
        name_fr: this.menuServices.menu_dish_array_tmp[i][6],
        name_it: this.menuServices.menu_dish_array_tmp[i][7],
        allergens: this.menuServices.menu_dish_array_tmp[i][8],
        foodcost_static: this.menuServices.menu_dish_array_tmp[i][9],
        foodcost_parts: this.menuServices.menu_dish_array_tmp[i][10],
        type: this.menuServices.menu_dish_array_tmp[i][11],
        price: this.menuServices.menu_dish_array_tmp[i][12],
        price_combo_extra: this.menuServices.menu_dish_array_tmp[i][13],
        price_takeaway: this.menuServices.menu_dish_array_tmp[i][14],
        description_es: this.menuServices.menu_dish_array_tmp[i][15],
        description_ca: this.menuServices.menu_dish_array_tmp[i][16],
        description_en: this.menuServices.menu_dish_array_tmp[i][17],
        description_de: this.menuServices.menu_dish_array_tmp[i][18],
        description_fr: this.menuServices.menu_dish_array_tmp[i][19],
        description_it: this.menuServices.menu_dish_array_tmp[i][20],
        tags: this.menuServices.menu_dish_array_tmp[i][21],
        image: this.menuServices.menu_dish_array_tmp[i][22]
      };
      this.globals.dataSet('menu_dish', this.menuServices.menu_dish_array_tmp[i][2], '', this.menuServices.menu_section_array_complete_tmp[this.section_index].name, '');
    }
    //
    this.menuServices.menu_section_array_complete_tmp[this.section_index].dish = _obj; // Insertamos dish al menu
    this.menuServices.menu_dish_array_tmp = Array(); //Limpiamos el array
  }

  updateFirestore() {
    this.menuServices.afs.collection('menus').doc(this.combo_uid).update({
      'sections': this.menuServices.menu_section_array_complete_tmp,
      'style': this.type
    }).then(() => {
    });
  }

  update() {
    if (this.navParams.get('new')) {
      this.analyticsServices.trackingExp('crear secció combo', this.globals.tracking_exp['create_section'], '');
    }
    this.updateSection();
    this.updateFirestore();
    this.recalculate();
    this.navCtrl.pop();
  }

  finishMenuSelect() {
    /*
    * Funcion para los estilo libre para terminar el menu y guardar
    */

    this.updateSection();// Anadimos los platos al array tmp de todas las secciones
    this.updateFirestore(); //Guardamos secciones en Firestore
    this.goToPriceExtras();

  }

  goToPriceExtras() {
    this.navCtrl.push(ComboCreatePricePage, {
      update: false,
      combo_uid: this.combo_uid,
      price: 0,
      price_takeaway: 0,
      extra_price: 0,
    });
  }

  ionViewDidLeave() {
    this.menuServices.menu_dish_array_tmp = Array();
  }

  openDishCreate() {
    this.dishServices.quick_create = true;
    this.navCtrl.push(DishCreateNamePage);
  }

  async recalculate() {
    for (var i = 0; Object.keys(this.menuServices.menu_section_array_complete_tmp).length > i; i++) {
      for (var j = 0; Object.keys(this.menuServices.menu_section_array_complete_tmp[i].dish).length > j; j++) {
        var element;
        if (this.menuServices.menu_section_array_complete_tmp[i].dish[j].type == 'product') {
          element = await this.productServices.getProduct(this.menuServices.menu_section_array_complete_tmp[i].dish[j].uid);
        } else {
          element = await this.dishServices.getDish(this.menuServices.menu_section_array_complete_tmp[i].dish[j].uid);
        }
        if (element != undefined) {
          this.menuServices.sumands = this.menuServices.sumands + parseFloat(element.foodcost_static);
          this.menuServices.count_tmp++;
        } else {
          this.menuServices.menu_section_array_complete_tmp[i].dish.splice(j, 1);
        }
      }
    }

    var menu = await this.menuServices.getMenu(this.combo_uid);

    this.menuServices.menu_cost = this.menuServices.sumands / this.menuServices.count_tmp;
    this.menuServices.menu_cost = this.menuServices.menu_cost + parseFloat(menu.extra);

    this.menuServices.afs.collection('menus').doc(this.combo_uid).update({
      'sections': this.menuServices.menu_section_array_complete_tmp,
    }).then(() => {
      this.staticsServices.updateMenuCost(this.combo_uid);
    });
  }

  deleteSection() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-seccion'),
      message: this.translate.instant('instant-seguro-quieres-eliminarla'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //delete
            delete this.menuServices.menu_tmp.sections[this.section_index];
            //reordenar
            var obj_help = {};
            var i = 0;
            for (let item of this.globals.objectToArray(this.menuServices.menu_tmp.sections)) {
              obj_help[i] = item;
              i++;
            }
            this.menuServices.menu_tmp.sections = obj_help;

            this.menuServices.afs.collection('menus').doc(this.combo_uid).update({
              'sections': this.menuServices.menu_tmp.sections,
            });
            this.menuServices.edit = false;
            this.navCtrl.pop();
          }
        }
      ]
    });
    alert.present();
  }
  searchProductsDishesNode(value) {
    this.menuServices.searchProductsDishesNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }

  rellenarIdiomasVacios() {
    // Detectar el idioma principal
    const mainLang = this.globals.restaurant.lang;
    let mainValue = '';
    switch (mainLang) {
      case 'es': mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name; break;
      case 'ca': mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name_ca; break;
      case 'en': mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name_en; break;
      case 'it': mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name_it; break;
      case 'fr': mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name_fr; break;
      case 'de': mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name_de; break;
      default: mainValue = this.menuServices.menu_section_array_complete_tmp[this.section_index].name;
    }
    if (!this.menuServices.menu_section_array_complete_tmp[this.section_index].name || this.menuServices.menu_section_array_complete_tmp[this.section_index].name.trim() === '') this.menuServices.menu_section_array_complete_tmp[this.section_index].name = mainValue;
    if (!this.menuServices.menu_section_array_complete_tmp[this.section_index].name_ca || this.menuServices.menu_section_array_complete_tmp[this.section_index].name_ca.trim() === '') this.menuServices.menu_section_array_complete_tmp[this.section_index].name_ca = mainValue;
    if (!this.menuServices.menu_section_array_complete_tmp[this.section_index].name_en || this.menuServices.menu_section_array_complete_tmp[this.section_index].name_en.trim() === '') this.menuServices.menu_section_array_complete_tmp[this.section_index].name_en = mainValue;
    if (!this.menuServices.menu_section_array_complete_tmp[this.section_index].name_it || this.menuServices.menu_section_array_complete_tmp[this.section_index].name_it.trim() === '') this.menuServices.menu_section_array_complete_tmp[this.section_index].name_it = mainValue;
    if (!this.menuServices.menu_section_array_complete_tmp[this.section_index].name_fr || this.menuServices.menu_section_array_complete_tmp[this.section_index].name_fr.trim() === '') this.menuServices.menu_section_array_complete_tmp[this.section_index].name_fr = mainValue;
    if (!this.menuServices.menu_section_array_complete_tmp[this.section_index].name_de || this.menuServices.menu_section_array_complete_tmp[this.section_index].name_de.trim() === '') this.menuServices.menu_section_array_complete_tmp[this.section_index].name_de = mainValue;
  }
}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-dish-select/combo-create-dish-select.ts